/**
 * @file コンポーネント：執刀医詳細モーダル スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledModalEdit = styled.p`
    margin-bottom: 16px;
    text-align: right;
`;

export const StyledModalEditLink = styled.a`
    color: #e0b03b;
    font-size: 13px;
    line-height: 14.6px;
`;

export const StyledModalEditLinkIcon = styled.span`
    margin-right: 4px;
`;

export const StyledModalEditLinkText = styled.span``;

export const StyledModalHeadline = styled.h4`
    margin-bottom: 6px;
    color: #212121;
    font-weight: normal;
    font-size: 14px;
    line-height: 15.7px;
`;

export const StyledModalParagraph = styled.p`
    margin-bottom: 16px;
    color: #212121;
    font-size: 13px;
    line-height: 14.6px;
`;
